// import { yupResolver } from '@hookform/resolvers/yup';
// import CloseIcon from '@mui/icons-material/Close';
// import {
//   Alert,
//   Avatar,
//   Box,
//   Button,
//   CircularProgress,
//   Divider,
//   FormControl,
//   FormControlLabel,
//   Grid,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Radio,
//   RadioGroup,
//   TextField,
//   Typography,
//   useMediaQuery,
//   useTheme
// } from '@mui/material';
// import { AppDispatch, RootState } from 'app/store';
// import React, { useEffect, useRef, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import {
//   FaCalendarAlt,
//   FaCamera,
//   FaCheckCircle,
//   FaClock,
//   FaExclamationTriangle,
//   FaFileAlt,
//   FaMapMarkerAlt,
//   FaSignature,
//   FaTools,
//   FaUndo,
//   FaUser
// } from 'react-icons/fa';
// import { FiArrowLeft } from 'react-icons/fi';
// import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { EquipmentIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
// import {
//   clearEquipmentIncidentState,
//   EquipmentIncidentFormData,
//   submitEquipmentIncident
// } from 'slices/NdisSlices/reportAllForms/equipmentIncidentSlice';
// import * as yup from 'yup';

// // Validation schemas
// const mainSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date: yup.string().required('Date of incident is required'),
//     time: yup.string().required('Time of incident is required'),
//     location: yup.string().required('Location is required'),
//     incident_type: yup.string().required('Incident type is required'),
//     description: yup.string().required('Incident description is required'),
//     damage_or_injury: yup.string().required('Description of damage/injury is required'),
//     was_injury: yup.string().required('Please specify if anyone was injured'),
//     immediate_actions: yup.string().required('Actions taken are required'),
//     maintenance_requested: yup
//       .string()
//       .required('Please specify if a maintenance request was made'),
//     reporter_name: yup.string().required('Reporter name is required'),
//     signature: yup.string().required('Signature is required'),
//     date_completed: yup.string().required('Date completed is required'),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// const followUpSchema = yup
//   .object({
//     id: yup.string().optional(),
//     date: yup.string().optional().default(''),
//     time: yup.string().optional().default(''),
//     location: yup.string().optional().default(''),
//     incident_type: yup.string().optional().default(''),
//     description: yup.string().optional().default(''),
//     damage_or_injury: yup.string().optional().default(''),
//     was_injury: yup.string().optional().default(''),
//     immediate_actions: yup.string().optional().default(''),
//     maintenance_requested: yup
//       .string()
//       .required('Please specify if a maintenance request was made'),
//     reporter_name: yup.string().optional().default(''),
//     signature: yup.string().optional().default(''),
//     date_completed: yup.string().optional().default(''),
//     photo: yup.mixed<File>().optional().default(undefined),
//     client_email: yup.string().optional().default('')
//   })
//   .required();

// interface Props {
//   initialData?: EquipmentIncident;
//   onClose?: () => void;
// }

// const EquipmentIncidentReportForm: React.FC<Props> = ({ initialData, onClose }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
//   const dispatch = useDispatch<AppDispatch>();
//   const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
//   const { message, loading, error } = useTypedSelector((state) => state.equipmentIncident);
//   const [previewImage, setPreviewImage] = useState<string | null>(null);
//   const fileInputRef = useRef<HTMLInputElement>(null);
//   const navigate = useNavigate();
//   const location = useLocation();

//   const searchParams = new URLSearchParams(location.search);
//   const tabParam = searchParams.get('tab') || 'incidents';
//   const incidentId = searchParams.get('id') || initialData?.id || undefined;

//   // Determine which form section to show based on route
//   const isMainFormRoute = location.pathname === '/equipment-IncidentReport';
//   const isFollowUpRoute =
//     location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

//   // Use separate useForm hooks for each route
//   const mainForm = useForm<EquipmentIncidentFormData>({
//     resolver: yupResolver(mainSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date: initialData?.date || '',
//       time: initialData?.time || '',
//       location: initialData?.location || '',
//       incident_type: initialData?.incident_type || '',
//       description: initialData?.description || '',
//       damage_or_injury: initialData?.damage_or_injury || '',
//       was_injury: initialData?.was_injury || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       maintenance_requested: initialData?.maintenance_requested || '',
//       reporter_name: initialData?.reporter_name || '',
//       signature: initialData?.signature || '',
//       date_completed: initialData?.date_completed || '',
//       photo: undefined,
//       client_email: ''
//     }
//   });

//   const followUpForm = useForm<EquipmentIncidentFormData>({
//     resolver: yupResolver(followUpSchema) as any,
//     defaultValues: {
//       id: initialData?.id || '',
//       date: initialData?.date || '',
//       time: initialData?.time || '',
//       location: initialData?.location || '',
//       incident_type: initialData?.incident_type || '',
//       description: initialData?.description || '',
//       damage_or_injury: initialData?.damage_or_injury || '',
//       was_injury: initialData?.was_injury || '',
//       immediate_actions: initialData?.immediate_actions || '',
//       maintenance_requested: initialData?.maintenance_requested || '',
//       reporter_name: initialData?.reporter_name || '',
//       signature: initialData?.signature || '',
//       date_completed: initialData?.date_completed || '',
//       photo: undefined,
//       client_email: ''
//     }
//   });

//   const was_injury = isMainFormRoute
//     ? mainForm.watch('was_injury')
//     : followUpForm.watch('was_injury');
//   const maintenance_requested = isMainFormRoute
//     ? mainForm.watch('maintenance_requested')
//     : followUpForm.watch('maintenance_requested');

//   const handleImageChange = (
//     e: React.ChangeEvent<HTMLInputElement>,
//     onChange: (value: File | undefined) => void
//   ) => {
//     const files = e.target.files;
//     if (files && files.length > 0) {
//       const file = files[0];
//       onChange(file);
//       const reader = new FileReader();
//       reader.onloadend = () => {
//         setPreviewImage(reader.result as string);
//       };
//       reader.readAsDataURL(file);
//     } else {
//       setPreviewImage(null);
//       onChange(undefined);
//     }
//   };

//   const handleRemoveImage = () => {
//     setPreviewImage(null);
//     if (isMainFormRoute) {
//       mainForm.setValue('photo', undefined, { shouldValidate: true });
//     } else {
//       followUpForm.setValue('photo', undefined, { shouldValidate: true });
//     }
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//   };

//   const onSubmitMain = async (data: EquipmentIncidentFormData) => {
//     try {
//       const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//         email?: string;
//       };
//       const client_email = selectedClient.email || '';
//       if (!client_email) {
//         mainForm.setError('client_email', {
//           type: 'manual',
//           message: 'Client email is required for submission'
//         });
//         return;
//       }

//       const payload: EquipmentIncidentFormData = {
//         ...data,
//         client_email
//       };

//       await dispatch(submitEquipmentIncident(payload)).unwrap();
//       mainForm.reset();
//       setPreviewImage(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearEquipmentIncidentState()), 5000);
//     } catch (err) {
//       console.error('Main form submission error:', err);
//       mainForm.setError('root', {
//         type: 'manual',
//         message: 'Failed to submit form. Please check all fields and try again.'
//       });
//     }
//   };

//   const onSubmitFollowUp = async (data: EquipmentIncidentFormData) => {
//     try {
//       if (!incidentId) {
//         followUpForm.setError('id', {
//           type: 'manual',
//           message: 'Incident ID is required for follow-up submission'
//         });
//         return;
//       }

//       const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
//         email?: string;
//       };
//       const client_email = selectedClient.email || '';
//       if (!client_email) {
//         followUpForm.setError('client_email', {
//           type: 'manual',
//           message: 'Client email is required for submission'
//         });
//         return;
//       }

//       const payload: EquipmentIncidentFormData = {
//         id: incidentId,
//         date: initialData?.date || data.date,
//         time: initialData?.time || data.time,
//         location: initialData?.location || data.location,
//         incident_type: initialData?.incident_type || data.incident_type,
//         description: initialData?.description || data.description,
//         damage_or_injury: initialData?.damage_or_injury || data.damage_or_injury,
//         was_injury: initialData?.was_injury || data.was_injury,
//         immediate_actions: initialData?.immediate_actions || data.immediate_actions,
//         maintenance_requested: data.maintenance_requested,
//         reporter_name: initialData?.reporter_name || data.reporter_name,
//         signature: initialData?.signature || data.signature,
//         date_completed: initialData?.date_completed || data.date_completed,
//         photo: initialData?.photo,
//         client_email
//       };

//       await dispatch(submitEquipmentIncident(payload)).unwrap();
//       followUpForm.reset();
//       setPreviewImage(null);
//       if (fileInputRef.current) {
//         fileInputRef.current.value = '';
//       }
//       setTimeout(() => dispatch(clearEquipmentIncidentState()), 5000);
//       if (onClose) {
//         onClose();
//       }
//     } catch (err) {
//       console.error('Follow-up form submission error:', err);
//       followUpForm.setError('root', {
//         type: 'manual',
//         message: 'Failed to submit follow-up form. Please check all fields and try again.'
//       });
//     }
//   };

//   const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     mainForm.reset();
//     mainForm.clearErrors();
//     setPreviewImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearEquipmentIncidentState());
//   };

//   const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
//     e.preventDefault();
//     followUpForm.reset();
//     followUpForm.clearErrors();
//     setPreviewImage(null);
//     if (fileInputRef.current) {
//       fileInputRef.current.value = '';
//     }
//     dispatch(clearEquipmentIncidentState());
//   };

//   useEffect(() => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//     // Log validation errors for debugging
//     if (isMainFormRoute && Object.keys(mainForm.formState.errors).length > 0) {
//       console.log('Main form validation errors:', mainForm.formState.errors);
//     }
//     if (isFollowUpRoute && Object.keys(followUpForm.formState.errors).length > 0) {
//       console.log('Follow-up form validation errors:', followUpForm.formState.errors);
//     }
//   }, [mainForm.formState.errors, followUpForm.formState.errors, isMainFormRoute, isFollowUpRoute]);

//   return (
//     <Box>
//       <Paper
//         elevation={isMobile ? 1 : 4}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
//         }}
//       >
//         {/* Header */}
//         <Box
//           sx={{
//             position: 'relative',
//             textAlign: 'center',
//             mb: isMobile ? 2 : 4,
//             px: isMobile ? 1 : 0
//           }}
//         >
//           {!isFollowUpRoute && (
//             <Button
//               onClick={() => navigate(-1)}
//               variant="outlined"
//               startIcon={<FiArrowLeft />}
//               sx={{
//                 position: 'absolute',
//                 left: 0,
//                 top: 0,
//                 borderColor:
//                   theme.palette.mode === 'light'
//                     ? 'rgba(0, 0, 0, 0.23)'
//                     : 'rgba(255, 255, 255, 0.23)',
//                 color: theme.palette.text.primary,
//                 textTransform: 'none',
//                 borderRadius: 2,
//                 px: 2,
//                 py: 1,
//                 '&:hover': {
//                   borderColor: theme.palette.primary.main,
//                   backgroundColor: theme.palette.action.hover
//                 },
//                 ...(isMobile && {
//                   fontSize: '0.75rem',
//                   px: 1.5,
//                   py: 0.5
//                 })
//               }}
//             >
//               {isMobile ? 'Back' : 'Back to Forms'}
//             </Button>
//           )}

//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               mb: 1,
//               flexDirection: isMobile ? 'column' : 'row',
//               mt: isMobile && !isFollowUpRoute ? 4 : 0,
//               gap: isMobile ? 1 : 2
//             }}
//           >
//             <Box
//               sx={{
//                 backgroundColor: theme.palette.primary.light,
//                 p: 1.5,
//                 borderRadius: '50%',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center'
//               }}
//             >
//               <FaFileAlt
//                 size={isMobile ? 24 : 32}
//                 style={{
//                   color: theme.palette.primary.dark
//                 }}
//               />
//             </Box>
//             <Typography
//               variant={isMobile ? 'h5' : 'h4'}
//               component="h1"
//               sx={{
//                 fontWeight: 600,
//                 lineHeight: 1.2,
//                 color: theme.palette.text.primary
//               }}
//             >
//               {isMainFormRoute
//                 ? 'Equipment, Property, or Vehicle Incident Report'
//                 : 'Equipment Incident Follow-Up Form'}
//             </Typography>
//           </Box>

//           <Typography
//             variant={isMobile ? 'body2' : 'subtitle1'}
//             sx={{
//               color: 'text.secondary',
//               maxWidth: 600,
//               margin: '0 auto',
//               px: isMobile ? 1 : 2,
//               lineHeight: 1.4
//             }}
//           >
//             Ultra Care Services -{' '}
//             {isMainFormRoute
//               ? 'For incidents involving equipment, property, or vehicles'
//               : 'For follow-up actions on equipment incidents'}
//           </Typography>
//         </Box>

//         {/* Success/Error Messages */}
//         {message && (
//           <Alert
//             severity="success"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearEquipmentIncidentState())}
//           >
//             {message}
//           </Alert>
//         )}
//         {error && (
//           <Alert
//             severity="error"
//             sx={{ mb: 2 }}
//             onClose={() => dispatch(clearEquipmentIncidentState())}
//           >
//             {error}
//           </Alert>
//         )}
//         {(mainForm.formState.errors.root || followUpForm.formState.errors.root) && (
//           <Alert severity="error" sx={{ mb: 2 }}>
//             {mainForm.formState.errors.root?.message ||
//               followUpForm.formState.errors.root?.message ||
//               'Please check all fields and try again.'}
//           </Alert>
//         )}

//         {isMainFormRoute && (
//           <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
//             {/* General Information */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaTools
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   General Information
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="date"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date of Incident"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date}
//                         helperText={mainForm.formState.errors.date?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="time"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Time of Incident"
//                         type="time"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaClock size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.time}
//                         helperText={mainForm.formState.errors.time?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="location"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Location"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaMapMarkerAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.location}
//                         helperText={mainForm.formState.errors.location?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Type of Incident
//                     </Typography>
//                     <Controller
//                       name="incident_type"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="Equipment"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Equipment
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Property"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Property
//                               </Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Vehicle"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Vehicle
//                               </Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.incident_type && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.incident_type.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Incident Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaExclamationTriangle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.error.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Incident Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="description"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description of the Incident"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.description}
//                         helperText={mainForm.formState.errors.description?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="damage_or_injury"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Description of Damage/Injury"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.damage_or_injury}
//                         helperText={mainForm.formState.errors.damage_or_injury?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Was Anyone Injured?
//                     </Typography>
//                     <Controller
//                       name="was_injury"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>
//                                 Yes (Please complete an incident report)
//                               </Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.was_injury && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.was_injury.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="immediate_actions"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Immediate Actions Taken"
//                         multiline
//                         rows={isMobile ? 3 : 4}
//                         fullWidth
//                         margin="normal"
//                         {...field}
//                         error={!!mainForm.formState.errors.immediate_actions}
//                         helperText={mainForm.formState.errors.immediate_actions?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="photo"
//                     control={mainForm.control}
//                     render={({ field: { onChange, onBlur, ...field } }) => (
//                       <Box>
//                         <TextField
//                           size="small"
//                           label="Upload Photo"
//                           type="file"
//                           fullWidth
//                           margin="normal"
//                           inputRef={fileInputRef}
//                           InputLabelProps={{ shrink: true }}
//                           InputProps={{
//                             startAdornment: (
//                               <InputAdornment position="start">
//                                 <FaCamera size={16} />
//                               </InputAdornment>
//                             ),
//                             inputProps: {
//                               accept: 'image/*'
//                             }
//                           }}
//                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
//                             handleImageChange(e, onChange)
//                           }
//                           onBlur={onBlur}
//                           error={!!mainForm.formState.errors.photo}
//                           helperText={mainForm.formState.errors.photo?.message}
//                         />
//                         {previewImage && isLargeScreen && (
//                           <Box sx={{ mt: 1, textAlign: 'left' }}>
//                             <Typography variant="subtitle2" sx={{ mb: 1 }}>
//                               Photo Preview
//                             </Typography>
//                             <Box sx={{ position: 'relative', display: 'inline-block' }}>
//                               <Avatar
//                                 src={previewImage}
//                                 variant="rounded"
//                                 sx={{
//                                   width: isMobile ? '100%' : 150,
//                                   height: 150,
//                                   objectFit: 'contain'
//                                 }}
//                               />
//                               <IconButton
//                                 size="small"
//                                 onClick={handleRemoveImage}
//                                 sx={{
//                                   position: 'absolute',
//                                   top: -10,
//                                   right: -10,
//                                   bgcolor: theme.palette.error.main,
//                                   color: theme.palette.common.white,
//                                   '&:hover': {
//                                     bgcolor: theme.palette.error.dark
//                                   }
//                                 }}
//                               >
//                                 <CloseIcon fontSize="small" />
//                               </IconButton>
//                             </Box>
//                           </Box>
//                         )}
//                       </Box>
//                     )}
//                   />
//                 </Grid>
//                 {previewImage && !isLargeScreen && (
//                   <Grid item xs={12}>
//                     <Box
//                       sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
//                     >
//                       <Box sx={{ position: 'relative' }}>
//                         <Avatar
//                           src={previewImage}
//                           variant="rounded"
//                           sx={{
//                             width: isMobile ? '100%' : 150,
//                             height: isMobile ? 150 : 150,
//                             mt: isMobile ? 1 : 0,
//                             objectFit: 'contain'
//                           }}
//                         />
//                         <IconButton
//                           size="small"
//                           onClick={handleRemoveImage}
//                           sx={{
//                             position: 'absolute',
//                             top: -10,
//                             right: -10,
//                             bgcolor: theme.palette.error.main,
//                             color: theme.palette.common.white,
//                             '&:hover': {
//                               bgcolor: theme.palette.error.dark
//                             }
//                           }}
//                         >
//                           <CloseIcon fontSize="small" />
//                         </IconButton>
//                       </Box>
//                     </Box>
//                   </Grid>
//                 )}
//               </Grid>
//             </Box>

//             {/* Follow-Up Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Have You Put in a Maintenance Request?
//                     </Typography>
//                     <Controller
//                       name="maintenance_requested"
//                       control={mainForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {mainForm.formState.errors.maintenance_requested && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {mainForm.formState.errors.maintenance_requested.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Reporter Details */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaUser
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.primary.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Reporter Details
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="reporter_name"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Name"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaUser size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.reporter_name}
//                         helperText={mainForm.formState.errors.reporter_name?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12} sm={6}>
//                   <Controller
//                     name="signature"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Signature"
//                         fullWidth
//                         margin="normal"
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaSignature size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.signature}
//                         helperText={mainForm.formState.errors.signature?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//                 <Grid item xs={12}>
//                   <Controller
//                     name="date_completed"
//                     control={mainForm.control}
//                     render={({ field }) => (
//                       <TextField
//                         size="small"
//                         label="Date Completed"
//                         type="date"
//                         fullWidth
//                         margin="normal"
//                         InputLabelProps={{ shrink: true }}
//                         InputProps={{
//                           startAdornment: (
//                             <InputAdornment position="start">
//                               <FaCalendarAlt size={16} />
//                             </InputAdornment>
//                           )
//                         }}
//                         {...field}
//                         error={!!mainForm.formState.errors.date_completed}
//                         helperText={mainForm.formState.errors.date_completed?.message}
//                       />
//                     )}
//                   />
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetMain}
//                 disabled={!mainForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Report'}
//               </Button>
//             </Box>
//           </form>
//         )}

//         {isFollowUpRoute && (
//           <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
//             {/* Follow-Up Actions */}
//             <Box sx={{ mb: isMobile ? 3 : 4 }}>
//               <Box
//                 sx={{
//                   display: 'flex',
//                   alignItems: 'center',
//                   mb: isMobile ? 1 : 2,
//                   pl: 1
//                 }}
//               >
//                 <FaCheckCircle
//                   size={isMobile ? 16 : 20}
//                   style={{
//                     marginRight: 8,
//                     color: theme.palette.success.main
//                   }}
//                 />
//                 <Typography
//                   variant={isMobile ? 'h6' : 'h5'}
//                   component="h2"
//                   sx={{
//                     fontWeight: 500,
//                     fontSize: isMobile ? '1.1rem' : '1.5rem'
//                   }}
//                 >
//                   Follow-Up Actions
//                 </Typography>
//               </Box>
//               <Divider sx={{ mb: isMobile ? 2 : 3 }} />

//               <Grid container spacing={isMobile ? 1 : 2}>
//                 <Grid item xs={12}>
//                   <FormControl component="fieldset" margin="normal" fullWidth>
//                     <Typography
//                       variant={isMobile ? 'subtitle2' : 'subtitle1'}
//                       sx={{ mb: 1, pl: 1 }}
//                     >
//                       Have You Put in a Maintenance Request?
//                     </Typography>
//                     <Controller
//                       name="maintenance_requested"
//                       control={followUpForm.control}
//                       render={({ field }) => (
//                         <RadioGroup
//                           {...field}
//                           onChange={(e) => field.onChange(e.target.value)}
//                           sx={{
//                             display: 'flex',
//                             flexDirection: isMobile ? 'column' : 'row',
//                             gap: isMobile ? 0.5 : 1,
//                             pl: 2
//                           }}
//                         >
//                           <FormControlLabel
//                             value="No"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
//                             }
//                           />
//                           <FormControlLabel
//                             value="Yes"
//                             control={<Radio size="small" color="primary" />}
//                             label={
//                               <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
//                             }
//                           />
//                         </RadioGroup>
//                       )}
//                     />
//                     {followUpForm.formState.errors.maintenance_requested && (
//                       <Typography color="error" variant="caption" sx={{ pl: 2 }}>
//                         {followUpForm.formState.errors.maintenance_requested.message}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 </Grid>
//               </Grid>
//             </Box>

//             {/* Submit and Reset Buttons */}
//             <Box
//               sx={{
//                 display: 'flex',
//                 justifyContent: 'center',
//                 gap: isMobile ? 2 : 3,
//                 mt: isMobile ? 3 : 4,
//                 mb: isMobile ? 1 : 0,
//                 flexDirection: isMobile ? 'column' : 'row'
//               }}
//             >
//               <Button
//                 type="button"
//                 variant="outlined"
//                 color="secondary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaUndo size={isMobile ? 14 : 18} />}
//                 onClick={handleResetFollowUp}
//                 disabled={!followUpForm.formState.isDirty || loading}
//               >
//                 Reset Form
//               </Button>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 size={isMobile ? 'medium' : 'large'}
//                 sx={{
//                   px: isMobile ? 4 : 6,
//                   py: isMobile ? 1 : 1.5,
//                   fontSize: isMobile ? '0.9rem' : '1.1rem',
//                   fontWeight: 600,
//                   borderRadius: 2,
//                   boxShadow: 1,
//                   '&:hover': {
//                     boxShadow: 3,
//                     transform: 'translateY(-1px)'
//                   },
//                   transition: 'all 0.2s ease',
//                   width: isMobile ? '100%' : 'auto'
//                 }}
//                 startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
//                 disabled={loading || !incidentId}
//               >
//                 {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
//               </Button>
//             </Box>
//           </form>
//         )}
//       </Paper>
//     </Box>
//   );
// };

// export default EquipmentIncidentReportForm;


import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import {
  Alert,
  Avatar,
  Box,
  Button,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import { AppDispatch, RootState } from 'app/store';
import React, { useEffect, useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import {
  FaCalendarAlt,
  FaCamera,
  FaCheckCircle,
  FaClock,
  FaExclamationTriangle,
  FaFileAlt,
  FaMapMarkerAlt,
  FaSignature,
  FaTools,
  FaUndo,
  FaUser
} from 'react-icons/fa';
import { FiArrowLeft } from 'react-icons/fi';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { EquipmentIncident } from 'slices/NdisSlices/carporateServices/IncidentsListSlice';
import {
  clearEquipmentIncidentState,
  EquipmentIncidentFormData,
  submitEquipmentIncident
} from 'slices/NdisSlices/reportAllForms/equipmentIncidentSlice';
import * as yup from 'yup';

// Validation schemas
const mainSchema = yup
  .object({
    id: yup.string().optional(),
    date: yup.string().required('Date of incident is required'),
    time: yup.string().required('Time of incident is required'),
    location: yup.string().required('Location is required'),
    incident_type: yup.string().required('Incident type is required'),
    description: yup.string().required('Incident description is required'),
    damage_or_injury: yup.string().required('Description of damage/injury is required'),
    was_injury: yup.string().required('Please specify if anyone was injured'),
    immediate_actions: yup.string().required('Actions taken are required'),
    maintenance_requested: yup
      .string()
      .required('Please specify if a maintenance request was made'),
    reporter_name: yup.string().required('Reporter name is required'),
    signature: yup.string().required('Signature is required'),
    date_completed: yup.string().required('Date completed is required'),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default(''),
    resolved: yup.string().optional().default('') // Added resolved as optional
  })
  .required();

const followUpSchema = yup
  .object({
    id: yup.string().optional(),
    date: yup.string().optional().default(''),
    time: yup.string().optional().default(''),
    location: yup.string().optional().default(''),
    incident_type: yup.string().optional().default(''),
    description: yup.string().optional().default(''),
    damage_or_injury: yup.string().optional().default(''),
    was_injury: yup.string().optional().default(''),
    immediate_actions: yup.string().optional().default(''),
    maintenance_requested: yup
      .string()
      .required('Please specify if a maintenance request was made'),
    resolved: yup
      .string()
      .oneOf(['Yes', 'No'], 'Please specify if the incident is resolved')
      .required('Please specify if the incident is resolved'), // Added resolved as required
    reporter_name: yup.string().optional().default(''),
    signature: yup.string().optional().default(''),
    date_completed: yup.string().optional().default(''),
    photo: yup.mixed<File>().optional().default(undefined),
    client_email: yup.string().optional().default('')
  })
  .required();

interface Props {
  initialData?: EquipmentIncident;
  onClose?: () => void;
}

const EquipmentIncidentReportForm: React.FC<Props> = ({ initialData, onClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch<AppDispatch>();
  const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
  const { message, loading, error } = useTypedSelector((state) => state.equipmentIncident);
  const [previewImage, setPreviewImage] = useState<string | null>(null);
  const [alreadyFilled, setAlreadyFilled] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const tabParam = searchParams.get('tab') || 'incidents';
  const incidentId = searchParams.get('id') || initialData?.id || undefined;

  // Determine which form section to show based on route
  const isMainFormRoute = location.pathname === '/equipment-IncidentReport';
  const isFollowUpRoute =
    location.pathname === '/ndis-operations/corporate-services' && tabParam === 'incidents';

  // Check if Follow-Up form is already filled
  useEffect(() => {
    if (isFollowUpRoute && initialData) {
      console.log('initialData', initialData);
      const isResolved = String(initialData?.resolved).toLowerCase() === 'yes';
      setAlreadyFilled(isResolved);
    } else {
      setAlreadyFilled(false);
    }
  }, [initialData, isFollowUpRoute]);
  

  // Use separate useForm hooks for each route
  const defaultDateTime = new Date().toISOString().split('T')[0];
  const mainForm = useForm<EquipmentIncidentFormData>({
    resolver: yupResolver(mainSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date: initialData?.date || defaultDateTime,
      time: initialData?.time || '',
      location: initialData?.location || '',
      incident_type: initialData?.incident_type || '',
      description: initialData?.description || '',
      damage_or_injury: initialData?.damage_or_injury || '',
      was_injury: initialData?.was_injury || '',
      immediate_actions: initialData?.immediate_actions || '',
      maintenance_requested: initialData?.maintenance_requested || '',
      reporter_name: initialData?.reporter_name || '',
      signature: initialData?.signature || '',
      date_completed: initialData?.date_completed || defaultDateTime,
      photo: undefined,
      client_email: '',
      resolved: initialData?.resolved || '' // Added resolved
    }
  });

  const followUpForm = useForm<EquipmentIncidentFormData>({
    resolver: yupResolver(followUpSchema) as any,
    defaultValues: {
      id: initialData?.id || '',
      date: initialData?.date || '',
      time: initialData?.time || '',
      location: initialData?.location || '',
      incident_type: initialData?.incident_type || '',
      description: initialData?.description || '',
      damage_or_injury: initialData?.damage_or_injury || '',
      was_injury: initialData?.was_injury || '',
      immediate_actions: initialData?.immediate_actions || '',
      maintenance_requested: initialData?.maintenance_requested || '',
      resolved: initialData?.resolved || '', // Added resolved
      reporter_name: initialData?.reporter_name || '',
      signature: initialData?.signature || '',
      date_completed: initialData?.date_completed || '',
      photo: undefined,
      client_email: ''
    }
  });

  const was_injury = isMainFormRoute
    ? mainForm.watch('was_injury')
    : followUpForm.watch('was_injury');
  const maintenance_requested = isMainFormRoute
    ? mainForm.watch('maintenance_requested')
    : followUpForm.watch('maintenance_requested');

  const handleImageChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    onChange: (value: File | undefined) => void
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      onChange(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result as string);
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewImage(null);
      onChange(undefined);
    }
  };

  const handleRemoveImage = () => {
    setPreviewImage(null);
    if (isMainFormRoute) {
      mainForm.setValue('photo', undefined, { shouldValidate: true });
    } else {
      followUpForm.setValue('photo', undefined, { shouldValidate: true });
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const onSubmitMain = async (data: EquipmentIncidentFormData) => {
    try {
      const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
        email?: string;
      };
      const client_email = selectedClient.email || '';
      if (!client_email) {
        mainForm.setError('client_email', {
          type: 'manual',
          message: 'Client email is required for submission'
        });
        return;
      }

      const payload: EquipmentIncidentFormData = {
        ...data,
        client_email
      };

      await dispatch(submitEquipmentIncident(payload)).unwrap();
      mainForm.reset();
      setPreviewImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearEquipmentIncidentState()), 5000);
    } catch (err) {
      console.error('Main form submission error:', err);
      mainForm.setError('root', {
        type: 'manual',
        message: 'Failed to submit form. Please check all fields and try again.'
      });
    }
  };

  const onSubmitFollowUp = async (data: EquipmentIncidentFormData) => {
    try {
      if (!incidentId) {
        followUpForm.setError('id', {
          type: 'manual',
          message: 'Incident ID is required for follow-up submission'
        });
        return;
      }

      const selectedClient = JSON.parse(localStorage.getItem('selectedClient') || '{}') as {
        email?: string;
      };
      const client_email = selectedClient.email || '';
      if (!client_email) {
        followUpForm.setError('client_email', {
          type: 'manual',
          message: 'Client email is required for submission'
        });
        return;
      }

      const payload: EquipmentIncidentFormData = {
        id: incidentId,
        date: initialData?.date || data.date,
        time: initialData?.time || data.time,
        location: initialData?.location || data.location,
        incident_type: initialData?.incident_type || data.incident_type,
        description: initialData?.description || data.description,
        damage_or_injury: initialData?.damage_or_injury || data.damage_or_injury,
        was_injury: initialData?.was_injury || data.was_injury,
        immediate_actions: initialData?.immediate_actions || data.immediate_actions,
        maintenance_requested: data.maintenance_requested,
        resolved: data.resolved, // Added resolved
        reporter_name: initialData?.reporter_name || data.reporter_name,
        signature: initialData?.signature || data.signature,
        date_completed: initialData?.date_completed || data.date_completed,
        photo: initialData?.photo,
        client_email
      };

      await dispatch(submitEquipmentIncident(payload)).unwrap();
      followUpForm.reset();
      setPreviewImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      setTimeout(() => dispatch(clearEquipmentIncidentState()), 5000);
      if (onClose) {
        onClose();
      }
    } catch (err) {
      console.error('Follow-up form submission error:', err);
      followUpForm.setError('root', {
        type: 'manual',
        message: 'Failed to submit follow-up form. Please check all fields and try again.'
      });
    }
  };

  const handleResetMain = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    mainForm.reset();
    mainForm.clearErrors();
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearEquipmentIncidentState());
  };

  const handleResetFollowUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    followUpForm.reset();
    followUpForm.clearErrors();
    setPreviewImage(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    dispatch(clearEquipmentIncidentState());
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (isMainFormRoute && Object.keys(mainForm.formState.errors).length > 0) {
      console.log('Main form validation errors:', mainForm.formState.errors);
    }
    if (isFollowUpRoute && Object.keys(followUpForm.formState.errors).length > 0) {
      console.log('Follow-up form validation errors:', followUpForm.formState.errors);
    }
  }, [mainForm.formState.errors, followUpForm.formState.errors, isMainFormRoute, isFollowUpRoute]);

  return (
    <Box>
      <Paper
        elevation={isMobile ? 1 : 4}
        sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          boxShadow: isMobile ? theme.shadows[1] : theme.shadows[4]
        }}
      >
        {/* Header */}
        <Box
          sx={{
            position: 'relative',
            textAlign: 'center',
            mb: isMobile ? 2 : 4,
            px: isMobile ? 1 : 0
          }}
        >
          {!isFollowUpRoute && (
            <Button
              onClick={() => navigate(-1)}
              variant="outlined"
              startIcon={<FiArrowLeft />}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
                borderColor:
                  theme.palette.mode === 'light'
                    ? 'rgba(0, 0, 0, 0.23)'
                    : 'rgba(255, 255, 255, 0.23)',
                color: theme.palette.text.primary,
                textTransform: 'none',
                borderRadius: 2,
                px: 2,
                py: 1,
                '&:hover': {
                  borderColor: theme.palette.primary.main,
                  backgroundColor: theme.palette.action.hover
                },
                ...(isMobile && {
                  fontSize: '0.75rem',
                  px: 1.5,
                  py: 0.5
                })
              }}
            >
              {isMobile ? 'Back' : 'Back to Forms'}
            </Button>
          )}

          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 1,
              flexDirection: isMobile ? 'column' : 'row',
              mt: isMobile && !isFollowUpRoute ? 4 : 0,
              gap: isMobile ? 1 : 2
            }}
          >
            <Box
              sx={{
                backgroundColor: theme.palette.primary.light,
                p: 1.5,
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <FaFileAlt
                size={isMobile ? 24 : 32}
                style={{
                  color: theme.palette.primary.dark
                }}
              />
            </Box>
            <Typography
              variant={isMobile ? 'h5' : 'h4'}
              component="h1"
              sx={{
                fontWeight: 600,
                lineHeight: 1.2,
                color: theme.palette.text.primary
              }}
            >
              {isMainFormRoute
                ? 'Equipment, Property, or Vehicle Incident Report'
                : 'Equipment Incident Follow-Up Form'}
            </Typography>
          </Box>

          <Typography
            variant={isMobile ? 'body2' : 'subtitle1'}
            sx={{
              color: 'text.secondary',
              maxWidth: 600,
              margin: '0 auto',
              px: isMobile ? 1 : 2,
              lineHeight: 1.4
            }}
          >
            Ultra Care Services -{' '}
            {isMainFormRoute
              ? 'For incidents involving equipment, property, or vehicles'
              : 'For follow-up actions on equipment incidents'}
          </Typography>
        </Box>

        {/* Success/Error Messages */}
        {message && (
          <Alert
            severity="success"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearEquipmentIncidentState())}
          >
            {message}
          </Alert>
        )}
        {error && (
          <Alert
            severity="error"
            sx={{ mb: 2 }}
            onClose={() => dispatch(clearEquipmentIncidentState())}
          >
            {error}
          </Alert>
        )}
        {(mainForm.formState.errors.root || followUpForm.formState.errors.root) && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {mainForm.formState.errors.root?.message ||
              followUpForm.formState.errors.root?.message ||
              'Please check all fields and try again.'}
          </Alert>
        )}
        {isFollowUpRoute && alreadyFilled && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            This follow-up form has already been filled.
          </Alert>
        )}

        {isMainFormRoute && (
          <form onSubmit={mainForm.handleSubmit(onSubmitMain)}>
            {/* General Information */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaTools
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  General Information
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="date"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date of Incident"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date}
                        helperText={mainForm.formState.errors.date?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="time"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Time of Incident"
                        type="time"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaClock size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.time}
                        helperText={mainForm.formState.errors.time?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="location"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Location"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaMapMarkerAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.location}
                        helperText={mainForm.formState.errors.location?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Type of Incident
                    </Typography>
                    <Controller
                      name="incident_type"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Equipment"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Equipment
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Property"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Property
                              </Typography>
                            }
                          />
                          <FormControlLabel
                            value="Vehicle"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Vehicle
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.incident_type && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.incident_type.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            {/* Incident Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaExclamationTriangle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.error.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Incident Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <Controller
                    name="description"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description of the Incident"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.description}
                        helperText={mainForm.formState.errors.description?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="damage_or_injury"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Description of Damage/Injury"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.damage_or_injury}
                        helperText={mainForm.formState.errors.damage_or_injury?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Was Anyone Injured?
                    </Typography>
                    <Controller
                      name="was_injury"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>
                                Yes (Please complete an incident report)
                              </Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.was_injury && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.was_injury.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="immediate_actions"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Immediate Actions Taken"
                        multiline
                        rows={isMobile ? 3 : 4}
                        fullWidth
                        margin="normal"
                        {...field}
                        error={!!mainForm.formState.errors.immediate_actions}
                        helperText={mainForm.formState.errors.immediate_actions?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="photo"
                    control={mainForm.control}
                    render={({ field: { onChange, onBlur, ...field } }) => (
                      <Box>
                        <TextField
                          size="small"
                          label="Upload Photo"
                          type="file"
                          fullWidth
                          margin="normal"
                          inputRef={fileInputRef}
                          InputLabelProps={{ shrink: true }}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <FaCamera size={16} />
                              </InputAdornment>
                            ),
                            inputProps: {
                              accept: 'image/*'
                            }
                          }}
                          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                            handleImageChange(e, onChange)
                          }
                          onBlur={onBlur}
                          error={!!mainForm.formState.errors.photo}
                          helperText={mainForm.formState.errors.photo?.message}
                        />
                        {previewImage && isLargeScreen && (
                          <Box sx={{ mt: 1, textAlign: 'left' }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                              Photo Preview
                            </Typography>
                            <Box sx={{ position: 'relative', display: 'inline-block' }}>
                              <Avatar
                                src={previewImage}
                                variant="rounded"
                                sx={{
                                  width: isMobile ? '100%' : 150,
                                  height: 150,
                                  objectFit: 'contain'
                                }}
                              />
                              <IconButton
                                size="small"
                                onClick={handleRemoveImage}
                                sx={{
                                  position: 'absolute',
                                  top: -10,
                                  right: -10,
                                  bgcolor: theme.palette.error.main,
                                  color: theme.palette.common.white,
                                  '&:hover': {
                                    bgcolor: theme.palette.error.dark
                                  }
                                }}
                              >
                                <CloseIcon fontSize="small" />
                              </IconButton>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    )}
                  />
                </Grid>
                {previewImage && !isLargeScreen && (
                  <Grid item xs={12}>
                    <Box
                      sx={{ display: 'flex', justifyContent: isMobile ? 'center' : 'flex-start' }}
                    >
                      <Box sx={{ position: 'relative' }}>
                        <Avatar
                          src={previewImage}
                          variant="rounded"
                          sx={{
                            width: isMobile ? '100%' : 150,
                            height: isMobile ? 150 : 150,
                            mt: isMobile ? 1 : 0,
                            objectFit: 'contain'
                          }}
                        />
                        <IconButton
                          size="small"
                          onClick={handleRemoveImage}
                          sx={{
                            position: 'absolute',
                            top: -10,
                            right: -10,
                            bgcolor: theme.palette.error.main,
                            color: theme.palette.common.white,
                            '&:hover': {
                              bgcolor: theme.palette.error.dark
                            }
                          }}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    </Box>
                  </Grid>
                )}
              </Grid>
            </Box>

            {/* Follow-Up Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Have You Put in a Maintenance Request?
                    </Typography>
                    <Controller
                      name="maintenance_requested"
                      control={mainForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {mainForm.formState.errors.maintenance_requested && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {mainForm.formState.errors.maintenance_requested.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            {/* Reporter Details */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaUser
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.primary.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Reporter Details
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="reporter_name"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Name"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaUser size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.reporter_name}
                        helperText={mainForm.formState.errors.reporter_name?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Controller
                    name="signature"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Signature"
                        fullWidth
                        margin="normal"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaSignature size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.signature}
                        helperText={mainForm.formState.errors.signature?.message}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    name="date_completed"
                    control={mainForm.control}
                    render={({ field }) => (
                      <TextField
                        size="small"
                        label="Date Completed"
                        type="date"
                        fullWidth
                        margin="normal"
                        InputLabelProps={{ shrink: true }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <FaCalendarAlt size={16} />
                            </InputAdornment>
                          )
                        }}
                        {...field}
                        error={!!mainForm.formState.errors.date_completed}
                        helperText={mainForm.formState.errors.date_completed?.message}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetMain}
                disabled={!mainForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Report'}
              </Button>
            </Box>
          </form>
        )}

        {isFollowUpRoute && (
          <form onSubmit={followUpForm.handleSubmit(onSubmitFollowUp)}>
            {/* Follow-Up Actions */}
            <Box sx={{ mb: isMobile ? 3 : 4 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: isMobile ? 1 : 2,
                  pl: 1
                }}
              >
                <FaCheckCircle
                  size={isMobile ? 16 : 20}
                  style={{
                    marginRight: 8,
                    color: theme.palette.success.main
                  }}
                />
                <Typography
                  variant={isMobile ? 'h6' : 'h5'}
                  component="h2"
                  sx={{
                    fontWeight: 500,
                    fontSize: isMobile ? '1.1rem' : '1.5rem'
                  }}
                >
                  Follow-Up Actions
                </Typography>
              </Box>
              <Divider sx={{ mb: isMobile ? 2 : 3 }} />

              <Grid container spacing={isMobile ? 1 : 2}>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Have You Put in a Maintenance Request?
                    </Typography>
                    <Controller
                      name="maintenance_requested"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.maintenance_requested && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.maintenance_requested.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl component="fieldset" margin="normal" fullWidth>
                    <Typography
                      variant={isMobile ? 'subtitle2' : 'subtitle1'}
                      sx={{ mb: 1, pl: 1 }}
                    >
                      Is the Incident Resolved?
                    </Typography>
                    <Controller
                      name="resolved"
                      control={followUpForm.control}
                      render={({ field }) => (
                        <RadioGroup
                          {...field}
                          onChange={(e) => field.onChange(e.target.value)}
                          sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'column' : 'row',
                            gap: isMobile ? 0.5 : 1,
                            pl: 2
                          }}
                        >
                          <FormControlLabel
                            value="Yes"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>Yes</Typography>
                            }
                          />
                          <FormControlLabel
                            value="No"
                            control={<Radio size="small" color="primary" />}
                            label={
                              <Typography variant={isMobile ? 'body2' : 'body1'}>No</Typography>
                            }
                          />
                        </RadioGroup>
                      )}
                    />
                    {followUpForm.formState.errors.resolved && (
                      <Typography color="error" variant="caption" sx={{ pl: 2 }}>
                        {followUpForm.formState.errors.resolved.message}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Box>

            {/* Submit and Reset Buttons */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: isMobile ? 2 : 3,
                mt: isMobile ? 3 : 4,
                mb: isMobile ? 1 : 0,
                flexDirection: isMobile ? 'column' : 'row'
              }}
            >
              <Button
                type="button"
                variant="outlined"
                color="secondary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaUndo size={isMobile ? 14 : 18} />}
                onClick={handleResetFollowUp}
                disabled={!followUpForm.formState.isDirty || loading}
              >
                Reset Form
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                size={isMobile ? 'medium' : 'large'}
                sx={{
                  px: isMobile ? 4 : 6,
                  py: isMobile ? 1 : 1.5,
                  fontSize: isMobile ? '0.9rem' : '1.1rem',
                  fontWeight: 600,
                  borderRadius: 2,
                  boxShadow: 1,
                  '&:hover': {
                    boxShadow: 3,
                    transform: 'translateY(-1px)'
                  },
                  transition: 'all 0.2s ease',
                  width: isMobile ? '100%' : 'auto'
                }}
                startIcon={<FaFileAlt size={isMobile ? 14 : 18} />}
                disabled={loading || !incidentId || alreadyFilled}
              >
                {loading ? <CircularProgress size={24} /> : 'Submit Follow-Up'}
              </Button>
            </Box>
          </form>
        )}
      </Paper>
    </Box>
  );
};

export default EquipmentIncidentReportForm;